import Styled from 'vue3-styled-components';

const ModalMain = Styled.div`
    // Form Validation
    .ant-form-item{
        .has-success{
            .ant-input{
                border-color: ${({theme}) => theme['success-color']};
            }
            &.ant-form-item-with-help{
                .ant-form-explain{
                    color: ${({theme}) => theme['success-color']};
                }
            }
        }
        &.ant-form-item-with-help{
            .ant-form-explain{
                margin: 6px 0 2px 0;
            }
        }
    }
    // Ant Input
    .ant-input{
        padding: 12px 11px;
        &::placeholder{
            color: #9299B8;
        }
    }
    .ant-input-affix-wrapper{
        padding: 12px 11px !important;
        font-size: 14px;
    }
    .ant-input-affix-wrapper-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-affix-wrapper-sm {
        padding: 3px 7px;
    }

    .ant-input-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-sm{
        padding: 3px 7px;
    }
`

const Main = Styled.div`
    padding: 0px 30px 20px;
    min-height: 715px;
    background-color: rgb(244, 245, 247);
    &.grid-boxed{
        padding: 0px 180px 20px;
        @media only screen and (max-width: 1599px){
            padding: 0px 130px 20px;
        }
        @media only screen and (max-width: 1399px){
            padding: 0px 50px 20px;
        }
        @media only screen and (max-width: 991px){
            padding: 0px 30px 20px;
        }
    }
    .ant-card-rtl .ant-card-extra{
                margin-right: 0 !important;
            }
    .ant-tabs-tab span svg {
        ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 5px;
    }
    /* Picker Under Input */
    .ant-form-item-control-input .ant-picker {
        padding: ${({theme}) => (theme.rtl ? '0 0 0 12px' : '0 12px 0 0')} !important;
    }

    /* progressbars */

    .ant-progress >div{
        display: inline-flex;
        align-items: center;
        width: 100%;
        position: relative;
        font-size: 14px;
    }

    .ant-progress .ant-progress-outer {
        ${({theme}) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 0 !important;
        ${({theme}) => (!theme.rtl ? 'padding-right' : 'padding-left')}: 0 !important;
    }

    .ant-progress .ant-progress-text {
        order: 0;
        margin-left: auto;
        ${({theme}) => (theme.rtl ? 'margin-right' : 'margin-left')}: 10px !important;
        align-self: flex-end;
        text-align: center;
    }

    .ant-progress-status-warning .ant-progress-bg {
        background: #fa8b0c;
    }

    /* progress bars */

    @media only screen and (max-width: 1199px){
        padding: 0px 15px;
    }
    @media only screen and (max-width: 991px){
        min-height: 580px;
    }
    .w-100{
        width: 100%;
    }
    .product-sidebar-col{
        @media only screen and (max-width: 767px){
            order: 2;
        }
    }
    .ant-skeleton-paragraph{
        margin-bottom: 0;
    }

    /* // ant alert */
    .ant-alert-closable{
        .ant-alert-message{
          ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
        }
    }

    .ant-alert-with-description .ant-alert-description{
        display: inline-block;
    }

    /* // ant Calendar Picker */
    .ant-picker-calendar{
        .ant-badge-status-text{
            color: ${({theme}) => theme['gray-color']};
        }
    }
    .ant-picker-calendar-header .ant-picker-calendar-year-select{
        @media only screen and (max-width: 400px){
            width: 50% !important;
        }
    }
    .ant-picker-calendar-header .ant-picker-calendar-month-select{
        @media only screen and (max-width: 400px){
            width: calc(50% - 8px) !important
        }
    }

    /* // Card Grid */
    .card-grid-wrap{
        .ant-card-grid{
            @media only screen and (max-width: 575px){
                width: 50% !important
            }
        }
    }

    /* // Drawer */
    .atbd-drawer{
        .ant-card-body{
            text-align: center;
        }
    }
    .drawer-placement{
        @media only screen and (max-width: 400px){
            text-align: center;
        }
        .ant-radio-group{
            margin: -4px;
            @media only screen and (max-width: 400px){
                margin-bottom: 15px;
            }
            .ant-radio-wrapper{
                margin: 4px;
            }
        }
    }
    .ant-drawer-content-wrapper{
        @media only screen and (max-width: 400px){
            width: 260px !important;
        }
        @media only screen and (max-width: 375px){
            width: 220px !important;
        }
    }

    /* // Input */
    .input-wrap{
        @media only screen and (max-width: 991px){
            min-height: 500px;
        }
        input::placeholder{
            color: ${({theme}) => theme['light-color']};
        }
    }
    /* // Modal Buttons */
    .modal-btns-wrap{
        margin: 0 -5px;
    }
    /* spinner */
    .ant-spin{
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 20px;
        &:last-child{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
        }
    }

    /* Column Cards Wrapper */
    .columnCardsWrapper{
        background: #F4F5F7;
        border-radius: 4px;
        padding: 50px 30px 25px;
    }
    .columnCardsWrapper .ant-card{
        background: #fff;
    }
    .columnCardsWrapper .ant-card-head{
        background: #fff;
    }

    /* Ant Collapse */
    .ant-collapse{
        border-color: #E3E6EF;
        border-radius: 5px;
    }
    .ant-collapse.ant-collapse-icon-position-left .ant-collapse-header{
        color: #5A5F7D;
        padding: 12px 16px 10px 45px;
        background-color: ${({theme}) => theme['bg-color-light']};
        line-height: 1.0;
    }
    .ant-collapse-content p{
        color: #9299B8;
        margin-bottom: 0;
    }
    .ant-collapse-content > .ant-collapse-content-box {
        padding: 20px 20px 12px;
    }
    .ant-collapse-content > .ant-collapse-content-box .ant-collapse-content-box{
        padding: 10.5px 20px;
    }
    .ant-collapse.ant-collapse-borderless{
        background-color: #fff;
    }
    .ant-collapse > .ant-collapse-item,
    .ant-collapse .ant-collapse-content{
        border-color: #E3E6EF;
    }
    .ant-collapse > .ant-collapse-item.ant-collapse-item-disabled .ant-collapse-header{
        color: #ADB4D2 !important;
    }

    .ant-collapse > .ant-collapse-item .ant-collapse-header .ant-collapse-arrow{
        font-size: 8px;
        color: ${({theme}) => theme['light-color']};
        svg,
        i{
            color: ${({theme}) => theme['light-color']};
        }
    }

    .ant-collapse .ant-collapse {
        border: 0 none;
        background: #fff;
    }

    .ant-collapse .ant-collapse > .ant-collapse-item {
        border-bottom: 0;
    }
    .ant-collapse .ant-collapse .ant-collapse-header{
        border: 1px solid #E3E6EF;
        background: #F8F9FB;
    }
    .ant-collapse .ant-collapse .ant-collapse-content{
        margin: 20px 0 10px 0;
        border: 1px solid #E3E6EF;
        border-radius: 0;
    }

    // Ant Collapse Borderless

    .ant-collapse.ant-collapse-borderless{
        .ant-collapse-item{
            background-color: #F8F9FB !important;
        }
    }

    // Ant Radio
    .ant-radio-button-wrapper{
        height: 48px;
        line-height: 46px;
        padding: 0 25.25px;
        @media only screen and (max-width: 1024px){
            padding: 0 10px;
        }
        @media only screen and (max-width: 379px){
            height: 40px !important;
            line-height: 38px !important;
            font-size: 12px;
            padding: 0 6px;
        }
    }

    .ant-radio-group-small{
        .ant-radio-button-wrapper{
            height: 30px;
            padding: 0 7px;
            line-height: 28px;
        }
    }

    // Ant Result
    .ant-result{
        .ant-result-icon{
            > .anticon{
                font-size: 50px;
            }
        }
    }
    .ant-result-title{
        font-size: 20px;
        line-height: 1.8;
        text-align: center;
        color: ${({theme}) => theme['dark-color']};
    }

    .ant-result-subtitle{
        color: #5a5f7d;
        font-size: 12px;
        line-height: 1.6;
        text-align: center;
    }

    .ant-result-extra{
        margin-top: 24px;
    }

    /* // Select */
    .sDash-select-vertical-list{
        .ant-select{
            &:not(:last-child){
                margin-bottom: 15px;
            }
        }
    }
    .ant-tree-select .ant-select-selector{
        height: 42px;
    }
    .tag-select-list{
        margin-bottom: -10px;
        .ant-select{
            margin-bottom: 10px;
        }
    }
    .ant-select-selector{
        border-color: #E3E6EF !important;
    }

    .ant-select{
        &.ant-select-multiple{
            .ant-select-selection-item{
                ${({theme}) => (!theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
            }
        }
        &.ant-select-lg{
            height: 50px;
            line-height: 48px;
            .ant-select-selector{
                height: 50px !important;
                line-height: 48px;
            }
            .ant-select-selection-item{
                line-height: 48px !important;
                ${({theme}) => (!theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
            }
            &.ant-select-multiple {
                .ant-select-selector{
                    padding: 1px 5px 5px 10px !important;
                }
                .ant-select-selection-item{
                    height: 32px;
                    line-height: 32px !important;
                }
            }
        }
        &.ant-select-multiple.ant-select-sm{
            .ant-select-selection-item{
                height: 16px;
                line-height: 14px;
                font-size: 11px;
            }
        }
    }

    .ant-select-multiple {
        .ant-select-selector{
            padding: 0 5px 0 10px !important;
            .ant-select-selection-item{
                height: 24px;
                line-height: 22px;
            }
        }
    }

    /* // Slider */
    .slider-with-input{
        .ant-slider{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
        }
        .slider-with-input__single{
            margin-bottom: 15px;
        }
    }

    /* // Taglist */
    .taglist-wrap{
        margin: -5px;
        .ant-tag {
            line-height: 22px;
            padding: 0 10.2px;
            border: 0 none;
            margin: 5px;
            color: ${({theme}) => theme['gray-color']};
            &.ant-tag-has-color{
                color: #fff !important;
            }
            &.ant-tag-magenta{
                color: #eb2f96;
            }
            &.ant-tag-red{
                color: #f5222d;
            }
            &.ant-tag-volcano{
                color: #fa541c;
            }
            &.ant-tag-orange{
                color: #fa8c16;
            }
            &.ant-tag-gold{
                color: #faad14;
            }
            &.ant-tag-line{
                color: #a0d911;
            }
            &.ant-tag-green{
                color: #a0d911;
            }
            &.ant-tag-cyan{
                color: #13c2c2;
            }
            &.ant-tag-blue{
                color: #1890ff;
            }
            &.ant-tag-geekbule{
                color: #2f54eb;
            }
            &.ant-tag-purple{
                color: #722ed1;
            }
        }
    }

    /* // Timepicker List */
    .timepicker-list{
        margin: -5px;
        .ant-picker{
            margin: 5px;
        }
    }

    /* // Ant Menu */
    .ant-menu{
        .ant-menu-submenu-title{
            svg{
                color: ${({theme}) => theme['light-color']};
            }
        }
    }

    /* Ant Comment */
    .ant-comment-inner{
        padding: 0;
    }
    .ant-comment-content-detail p{
        color: #9299B8;
    }

    .ant-list-items{
        padding-top: 22px;
        .ant-list-item{
            padding: 0;
            border-bottom: 0 none;
        }
    }
    .ant-list-items li:not(:last-child){
        margin-bottom: 22px;
    }
    .ant-comment:not(:last-child){
        margin-bottom: 22px;
    }
    .ant-comment-nested{
        margin-top: 22px;
    }
    .ant-comment-actions li span{
        color: #ADB4D2;
    }
    .ant-comment-content-detail textarea{
        resize: none;
        min-height: 170px;
        border-radius: 5px;
    }

    // Ant List
    .ant-list.ant-list-bordered{
        .ant-list-header,
        .ant-list-footer{
            padding: 13px 16px;
        }
        .ant-list-items{
            padding-top: 0;
            .ant-list-item{
                padding: 12.5px 16px;
                margin-bottom: 0;
                color: ${({theme}) => theme['gray-color']};
            }
        }
    }

    /* // Vector Map */
    .rsm_map{
        min-height: 505px;
        .world-map{
            width: 100%;
            height: auto;
            @media only screen and (max-width: 1599px){
                height: 480px;
            }
            @media only screen and (max-width: 1399px){
                height: 400px;
            }
            @media only screen and (max-width: 575px){
                height: 400px;
            }
            @media only screen and (max-width: 767px){
                height: 300px;
            }
            @media only screen and (max-width: 575px){
                height: 250px;
            }
            @media only screen and (max-width: 479px){
                height: 350px;
            }
            @media only screen and (max-width: 375px){
                height: 240px;
            }
        }
        .controls{
            position: absolute;
            right: 30px;
            bottom: 30px;
            button{
                display: block;
                width: 27px;
                height: 27px;
                background: none;
                color: #5a5f7d;
                border: 1px solid #f1f2f6;
                padding: 0;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #fff;
                cursor: pointer;
                &:first-child{
                    border-radius: 6px 6px 0 0;
                }
                &:last-child{
                    border-radius: 0 0 6px 6px;
                }
                &:focus{
                    outline: none;
                }
                svg{
                    width: 10px;
                }
            }
            button + button{
                border-top: 0 none;
            }
        }
    }

    /* // Checkout Wrapper */
    .checkoutWraper{
        .ant-card-body{
            padding: 50px 50px 50px 30px !important;
            @media only screen and (max-width: 575px){
                padding: 25px !important;
            }
            .ant-card-body{
                padding: 25px !important;
                @media only screen and (max-width: 375px){
                    padding: 15px !important;
                }
            }
        }
        .ant-steps{
            margin-top: -22px;
        }
    }

    /* // Star Active */
    a{
        i,
        span.fa{
          font-size: 16px;
          color: ${({theme}) => theme['extra-light-color']};
          line-height: 0;
        }
        &.starDeactivate{
          i:before{
            content: "\f31b";
          }
        }
        &.starActive{
          i,
          span.fa{
            color: ${({theme}) => theme['warning-color']};
          }
          i:before,
          span.fa:before{
            color: ${({theme}) => theme['warning-color']};
            content: "\f005";

          }
        }
    }

    .ant-timeline{
        color: ${({theme}) => theme['gray-color']};
        .ant-timeline-item-content{
            font-size: 16px;
        }
    }


    .ant-rate{
        .ant-rate-star{
            svg{
                width: 13px;
                height: 13px;
            }
        }
    }

    .ant-rate-content{
        font-weight: 500;
        color: ${({theme}) => theme['gray-color']}
    }

    .account-card{
        .ant-card-head{
            .ant-card-extra{
                @media only screen and (max-width: 575px){
                   padding-top: 0 !important;
                }
            }

        }

    }

    /* // Rechart */
    .recharts-default-legend{
        .recharts-legend-item{
            min-width: 100px !important;
        }
    }

    /* // Radio */
    .radio-size-wrap{
            .ant-radio-button-wrapper{
                @media only screen and (max-width: 1450px){
                    padding: 0 11.5px;
                }
                @media only screen and (max-width: 450px){
                    padding: 0 5.5px;
                }
            }
        }
    }

    /* // Message  */
    .message-button-list{
        margin: -4px;
        .ant-btn {
            margin: 4px;
        }
    }
    /* Chart Label */

    .chart-label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 6px;
        color: #5a5f7d;
    }

    .chart-label .label-dot {
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
    }

    .chart-label .label-dot.dot-success {
        background: #20c997;
    }

    .chart-label .label-dot.dot-info {
        background: #5f63f2;
    }

    .chart-label .label-dot.dot-warning {
        background: #fa8b0c;
    }

    .chart-label .label-dot {
        display: block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 10px;
    }

    // Ant comment
    .ant-comment-actions{
        li{
            position: relative;
            &:not(:last-child){
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
                ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
                &:after{
                    position: absolute;
                    ${({theme}) => (theme.rtl ? 'left' : 'right')}: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 12px;
                    background-color: #C6D0DC;
                    content: '';
                }
            }
            .com-time{
                cursor: default;
            }
            >span{
                ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 0;
            }
            span{
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
            }
        }

        .comment-ld-action{
            ${({theme}) => (theme.rtl ? 'padding-right' : 'padding-left')}: 8px;
            cursor: auto;
        }
    }

    .ant-comment{
        .ant-comment-content{
            .add-comment{
                margin-top: 25px;
                font-size: 14px;
                padding: 0px 25px;
                box-shadow: 0 8px 13px ${({theme}) => theme['primary-color']}20;
            }
        }
    }

    // Emoji Picker React
    .emoji-picker-react{
        bottom: 15px;
        right: 25px;
        box-shadow: 0 5px 10px #efefef10;
        @media only screen and (max-width: 479px){
            bottom: 25px;
            right: -50px;
            width: 260px;
        }
        .emoji-categories{
            padding: 0 10px;
        }
        .emoji-search{
            margin: 0 10px;
        }
        .content-wrapper:before{
            display: none;
        }
        .emoji-group{
            padding: 0 10px;
        }
        .emoji-group:before{
            font-size: 12px;
            font-weight: 600;
            color: ${({theme}) => theme['dark-color']};
        }
        .emoji-group .emoji-img{
            margin: 5px !important;
        }
    }

    .wizard-side-border{
        >.ant-card{
            .ant-card-body{
                padding: 0 25px !important;
            }
        }
        .checkout-successful{
            >.ant-card{
                .ant-card-body{
                    padding: 25px !important;
                }
            }
        }
        .payment-method-form.theme-light{
            .shipping-selection__card{
                .ant-card-body{
                    padding: 25px !important;
                }
            }
        }
        .shipping-selection__card{
            .ant-card-body{
                padding: 25px !important;
            }
        }
        .atbd-review-order{
            .ant-card-body{
                padding: 25px 25px 0 !important;
                @media only screen and (max-width: 767px) {
                    padding: 15px 15px 0 !important;
                }
            }
        }

        .ant-steps {
            padding: 50px;
            @media only screen and (max-width: 1399px) {
                padding: 25px;
            }
        }
        .steps-wrapper{
            padding: 50px;
            @media only screen and (max-width: 1399px) {
                padding: 25px;
            }
            ${({theme}) => (theme.rtl ? 'border-right' : 'border-left')}: 1px solid ${({theme}) =>
    theme['border-color-light']};
        }
    }
    .editor-compose > div {
        position: static;
        max-width: 100%;
        margin: 25px 0;
    }

    // Ant Dragger
    .ant-upload-drag{
        background-color: #fff !important;
        border-radius: 10px !important;
        display: flex;
        align-items: center;
        min-height: 100px;
        border-color: #C6D0DC;

        .ant-upload-drag-container{
            .ant-upload-text{
                margin-bottom: 0;
                font-size: 15px;
                color: #9299B8;
            }
        }
    }

    .sDash-uploader-large{
        .ant-upload-drag{
            min-height: 180px;
        }
    }

    // Form Validation
    .ant-form-item{
        .has-success{
            .ant-input{
                border-color: ${({theme}) => theme['success-color']};
            }
            &.ant-form-item-with-help{
                .ant-form-explain{
                    color: ${({theme}) => theme['success-color']};
                }
            }
        }
        &.ant-form-item-with-help{
            .ant-form-explain{
                margin: 6px 0 2px 0;
            }
        }
    }

    // Statistics Account Balance
    .sDash-ac-balance{
        .sDash-rcharge-btn{
            font-size: 14px;
            margin-top: 15px;
            height: 42px !important;
        }
    }

    // Switch Style

    .ant-switch{
        min-width: 35px;
    }

    .ant-switch-small{
        min-width: 30px;
        height: 15px;
        line-height: 15px;
    }

    // Ant Picker
    .ant-time-picker{
        min-width: 250px;
        .ant-time-picker-input{
            padding: 12px 11px;
        }
        &.ant-time-picker-large{
            .ant-time-picker-input{
                padding: 12px 11px;
            }
        }
        &.ant-time-picker-small{
            .ant-time-picker-input{
                padding: 8px 11px;
            }
        }
    }

    .sDash-dynamic-tag{
        .sDash-new-tag-input{
            background-color: #EFF0F3;
        }
        .ant-input{
            height: 30px;
        }
    }

    // Ant Tab
    .ant-tabs-top-bar{
        .ant-tabs-nav{
            margin: 0 0 16px;
            .ant-tabs-tab{
                i{
                    line-height: .6;
                }
            }
        }
    }

    // Ant Input
    .ant-input{
        padding: 12px 11px;
        &::placeholder{
            color: #9299B8;
        }
    }
    .ant-input-affix-wrapper{
        padding: 12px 11px !important;
        font-size: 14px;
    }
    .ant-input-affix-wrapper-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-affix-wrapper-sm {
        padding: 3px 7px;
    }

    .ant-input-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-sm{
        padding: 3px 7px;
    }

    #world-map{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-form-item-label{
        line-height: 1.5715;
    }
    .ant-form-vertical .ant-form-item{
        padding-bottom: 0;
    }

    .ant-checkbox-wrapper{
        span + span{
            color: ${({theme}) => theme['light-color']};
        }
    }
    .ant-menu{
        .ant-menu-item{
            svg,
            i{
                color: ${({theme}) => theme['light-color']};
            }
        }
    }
    .sDash-action-btn-list{
        &.ant-space{
            margin: -4px !important;
            .ant-space-item{
                margin: 4px !important
            }
        }
    }

    // Switch List
    .sDash-switch-list{
        margin: 0 -5px;
        button{
            margin: 0 5px;
        }
    }

    // Ant tabs
    .ant-tabs-tab-prev-icon,
    .ant-tabs-tab-next-icon{
        top: 40%;
    }

    .sDash-drawer-placement{
        .ant-radio-group{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        }
    }
`;

const RelationMain = Styled.div`
    min-height: 715px;
    background-color: rgb(244, 245, 247);
    &.grid-boxed{
        padding: 0px 180px 20px;
        @media only screen and (max-width: 1599px){
            padding: 0px 130px 20px;
        }
        @media only screen and (max-width: 1399px){
            padding: 0px 50px 20px;
        }
        @media only screen and (max-width: 991px){
            padding: 0px 30px 20px;
        }
    }
    .ant-card-rtl .ant-card-extra{
                margin-right: 0 !important;
            }
    .ant-tabs-tab span svg {
        ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 5px;
    }
    /* Picker Under Input */
    .ant-form-item-control-input .ant-picker {
        padding: ${({theme}) => (theme.rtl ? '0 0 0 12px' : '0 12px 0 0')} !important;
    }

    /* progressbars */

    .ant-progress >div{
        display: inline-flex;
        align-items: center;
        width: 100%;
        position: relative;
        font-size: 14px;
    }

    .ant-progress .ant-progress-outer {
        ${({theme}) => (!theme.rtl ? 'margin-right' : 'margin-left')}: 0 !important;
        ${({theme}) => (!theme.rtl ? 'padding-right' : 'padding-left')}: 0 !important;
    }

    .ant-progress .ant-progress-text {
        order: 0;
        margin-left: auto;
        ${({theme}) => (theme.rtl ? 'margin-right' : 'margin-left')}: 10px !important;
        align-self: flex-end;
        text-align: center;
    }

    .ant-progress-status-warning .ant-progress-bg {
        background: #fa8b0c;
    }

    /* progress bars */

    @media only screen and (max-width: 1199px){
        padding: 0px 15px;
    }
    @media only screen and (max-width: 991px){
        min-height: 580px;
    }
    .w-100{
        width: 100%;
    }
    .product-sidebar-col{
        @media only screen and (max-width: 767px){
            order: 2;
        }
    }
    .ant-skeleton-paragraph{
        margin-bottom: 0;
    }

    /* // ant alert */
    .ant-alert-closable{
        .ant-alert-message{
          ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
        }
    }

    .ant-alert-with-description .ant-alert-description{
        display: inline-block;
    }

    /* // ant Calendar Picker */
    .ant-picker-calendar{
        .ant-badge-status-text{
            color: ${({theme}) => theme['gray-color']};
        }
    }
    .ant-picker-calendar-header .ant-picker-calendar-year-select{
        @media only screen and (max-width: 400px){
            width: 50% !important;
        }
    }
    .ant-picker-calendar-header .ant-picker-calendar-month-select{
        @media only screen and (max-width: 400px){
            width: calc(50% - 8px) !important
        }
    }

    /* // Card Grid */
    .card-grid-wrap{
        .ant-card-grid{
            @media only screen and (max-width: 575px){
                width: 50% !important
            }
        }
    }

    /* // Drawer */
    .atbd-drawer{
        .ant-card-body{
            text-align: center;
        }
    }
    .drawer-placement{
        @media only screen and (max-width: 400px){
            text-align: center;
        }
        .ant-radio-group{
            margin: -4px;
            @media only screen and (max-width: 400px){
                margin-bottom: 15px;
            }
            .ant-radio-wrapper{
                margin: 4px;
            }
        }
    }
    .ant-drawer-content-wrapper{
        @media only screen and (max-width: 400px){
            width: 260px !important;
        }
        @media only screen and (max-width: 375px){
            width: 220px !important;
        }
    }

    /* // Input */
    .input-wrap{
        @media only screen and (max-width: 991px){
            min-height: 500px;
        }
        input::placeholder{
            color: ${({theme}) => theme['light-color']};
        }
    }
    /* // Modal Buttons */
    .modal-btns-wrap{
        margin: 0 -5px;
    }
    /* spinner */
    .ant-spin{
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 20px;
        &:last-child{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
        }
    }

    /* Column Cards Wrapper */
    .columnCardsWrapper{
        background: #F4F5F7;
        border-radius: 4px;
        padding: 50px 30px 25px;
    }
    .columnCardsWrapper .ant-card{
        background: #fff;
    }
    .columnCardsWrapper .ant-card-head{
        background: #fff;
    }

    /* Ant Collapse */
    .ant-collapse{
        border-color: #E3E6EF;
        border-radius: 5px;
    }
    .ant-collapse.ant-collapse-icon-position-left .ant-collapse-header{
        color: #5A5F7D;
        padding: 12px 16px 10px 45px;
        background-color: ${({theme}) => theme['bg-color-light']};
    }
    .ant-collapse-content p{
        color: #9299B8;
        margin-bottom: 0;
    }
    .ant-collapse-content > .ant-collapse-content-box {
        padding: 20px 20px 12px;
    }
    .ant-collapse-content > .ant-collapse-content-box .ant-collapse-content-box{
        padding: 10.5px 20px;
    }
    .ant-collapse.ant-collapse-borderless{
        background-color: #fff;
    }
    .ant-collapse > .ant-collapse-item,
    .ant-collapse .ant-collapse-content{
        border-color: #E3E6EF;
    }
    .ant-collapse > .ant-collapse-item.ant-collapse-item-disabled .ant-collapse-header{
        color: #ADB4D2 !important;
    }

    .ant-collapse > .ant-collapse-item .ant-collapse-header .ant-collapse-arrow{
        font-size: 8px;
        color: ${({theme}) => theme['light-color']};
        svg,
        i{
            color: ${({theme}) => theme['light-color']};
        }
    }

    .ant-collapse .ant-collapse {
        border: 0 none;
        background: #fff;
    }

    .ant-collapse .ant-collapse > .ant-collapse-item {
        border-bottom: 0;
    }
    .ant-collapse .ant-collapse .ant-collapse-header{
        border: 1px solid #E3E6EF;
        background: #F8F9FB;
    }
    .ant-collapse .ant-collapse .ant-collapse-content{
        margin: 20px 0 10px 0;
        border: 1px solid #E3E6EF;
        border-radius: 0;
    }

    // Ant Collapse Borderless

    .ant-collapse.ant-collapse-borderless{
        .ant-collapse-item{
            background-color: #F8F9FB !important;
        }
    }

    // Ant Radio
    .ant-radio-button-wrapper{
        height: 48px;
        line-height: 46px;
        padding: 0 25.25px;
        @media only screen and (max-width: 1024px){
            padding: 0 10px;
        }
        @media only screen and (max-width: 379px){
            height: 40px !important;
            line-height: 38px !important;
            font-size: 12px;
            padding: 0 6px;
        }
    }

    .ant-radio-group-small{
        .ant-radio-button-wrapper{
            height: 30px;
            padding: 0 7px;
            line-height: 28px;
        }
    }

    // Ant Result
    .ant-result{
        .ant-result-icon{
            > .anticon{
                font-size: 50px;
            }
        }
    }
    .ant-result-title{
        font-size: 20px;
        line-height: 1.8;
        text-align: center;
        color: ${({theme}) => theme['dark-color']};
    }

    .ant-result-subtitle{
        color: #5a5f7d;
        font-size: 12px;
        line-height: 1.6;
        text-align: center;
    }

    .ant-result-extra{
        margin-top: 24px;
    }

    /* // Select */
    .sDash-select-vertical-list{
        .ant-select{
            &:not(:last-child){
                margin-bottom: 15px;
            }
        }
    }
    .ant-tree-select .ant-select-selector{
        height: 42px;
    }
    .tag-select-list{
        margin-bottom: -10px;
        .ant-select{
            margin-bottom: 10px;
        }
    }
    .ant-select-selector{
        border-color: #E3E6EF !important;
    }

    .ant-select{
        &.ant-select-multiple{
            .ant-select-selection-item{
                ${({theme}) => (!theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
            }
        }
        &.ant-select-lg{
            height: 50px;
            line-height: 48px;
            .ant-select-selector{
                height: 50px !important;
                line-height: 48px;
            }
            .ant-select-selection-item{
                line-height: 48px !important;
                ${({theme}) => (!theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
            }
            &.ant-select-multiple {
                .ant-select-selector{
                    padding: 1px 5px 5px 10px !important;
                }
                .ant-select-selection-item{
                    height: 32px;
                    line-height: 32px !important;
                }
            }
        }
        &.ant-select-multiple.ant-select-sm{
            .ant-select-selection-item{
                height: 16px;
                line-height: 14px;
                font-size: 11px;
            }
        }
    }

    .ant-select-multiple {
        .ant-select-selector{
            padding: 0 5px 0 10px !important;
            .ant-select-selection-item{
                height: 24px;
                line-height: 22px;
            }
        }
    }

    /* // Slider */
    .slider-with-input{
        .ant-slider{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 15px;
        }
        .slider-with-input__single{
            margin-bottom: 15px;
        }
    }

    /* // Taglist */
    .taglist-wrap{
        margin: -5px;
        .ant-tag {
            line-height: 22px;
            padding: 0 10.2px;
            border: 0 none;
            margin: 5px;
            color: ${({theme}) => theme['gray-color']};
            &.ant-tag-has-color{
                color: #fff !important;
            }
            &.ant-tag-magenta{
                color: #eb2f96;
            }
            &.ant-tag-red{
                color: #f5222d;
            }
            &.ant-tag-volcano{
                color: #fa541c;
            }
            &.ant-tag-orange{
                color: #fa8c16;
            }
            &.ant-tag-gold{
                color: #faad14;
            }
            &.ant-tag-line{
                color: #a0d911;
            }
            &.ant-tag-green{
                color: #a0d911;
            }
            &.ant-tag-cyan{
                color: #13c2c2;
            }
            &.ant-tag-blue{
                color: #1890ff;
            }
            &.ant-tag-geekbule{
                color: #2f54eb;
            }
            &.ant-tag-purple{
                color: #722ed1;
            }
        }
    }

    /* // Timepicker List */
    .timepicker-list{
        margin: -5px;
        .ant-picker{
            margin: 5px;
        }
    }

    /* // Ant Menu */
    .ant-menu{
        .ant-menu-submenu-title{
            svg{
                color: ${({theme}) => theme['light-color']};
            }
        }
    }

    /* Ant Comment */
    .ant-comment-inner{
        padding: 0;
    }
    .ant-comment-content-detail p{
        color: #9299B8;
    }

    .ant-list-items{
        padding-top: 22px;
        .ant-list-item{
            padding: 0;
            border-bottom: 0 none;
        }
    }
    .ant-list-items li:not(:last-child){
        margin-bottom: 22px;
    }
    .ant-comment:not(:last-child){
        margin-bottom: 22px;
    }
    .ant-comment-nested{
        margin-top: 22px;
    }
    .ant-comment-actions li span{
        color: #ADB4D2;
    }
    .ant-comment-content-detail textarea{
        resize: none;
        min-height: 170px;
        border-radius: 5px;
    }

    // Ant List
    .ant-list.ant-list-bordered{
        .ant-list-header,
        .ant-list-footer{
            padding: 13px 16px;
        }
        .ant-list-items{
            padding-top: 0;
            .ant-list-item{
                padding: 12.5px 16px;
                margin-bottom: 0;
                color: ${({theme}) => theme['gray-color']};
            }
        }
    }

    /* // Vector Map */
    .rsm_map{
        min-height: 505px;
        .world-map{
            width: 100%;
            height: auto;
            @media only screen and (max-width: 1599px){
                height: 480px;
            }
            @media only screen and (max-width: 1399px){
                height: 400px;
            }
            @media only screen and (max-width: 575px){
                height: 400px;
            }
            @media only screen and (max-width: 767px){
                height: 300px;
            }
            @media only screen and (max-width: 575px){
                height: 250px;
            }
            @media only screen and (max-width: 479px){
                height: 350px;
            }
            @media only screen and (max-width: 375px){
                height: 240px;
            }
        }
        .controls{
            position: absolute;
            right: 30px;
            bottom: 30px;
            button{
                display: block;
                width: 27px;
                height: 27px;
                background: none;
                color: #5a5f7d;
                border: 1px solid #f1f2f6;
                padding: 0;
                font-size: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: #fff;
                cursor: pointer;
                &:first-child{
                    border-radius: 6px 6px 0 0;
                }
                &:last-child{
                    border-radius: 0 0 6px 6px;
                }
                &:focus{
                    outline: none;
                }
                svg{
                    width: 10px;
                }
            }
            button + button{
                border-top: 0 none;
            }
        }
    }

    /* // Checkout Wrapper */
    .checkoutWraper{
        .ant-card-body{
            padding: 50px 50px 50px 30px !important;
            @media only screen and (max-width: 575px){
                padding: 25px !important;
            }
            .ant-card-body{
                padding: 25px !important;
                @media only screen and (max-width: 375px){
                    padding: 15px !important;
                }
            }
        }
        .ant-steps{
            margin-top: -22px;
        }
    }

    /* // Star Active */
    a{
        i,
        span.fa{
          font-size: 16px;
          color: ${({theme}) => theme['extra-light-color']};
          line-height: 0;
        }
        &.starDeactivate{
          i:before{
            content: "\f31b";
          }
        }
        &.starActive{
          i,
          span.fa{
            color: ${({theme}) => theme['warning-color']};
          }
          i:before,
          span.fa:before{
            color: ${({theme}) => theme['warning-color']};
            content: "\f005";

          }
        }
    }

    .ant-timeline{
        color: ${({theme}) => theme['gray-color']};
        .ant-timeline-item-content{
            font-size: 16px;
        }
    }


    .ant-rate{
        .ant-rate-star{
            svg{
                width: 13px;
                height: 13px;
            }
        }
    }

    .ant-rate-content{
        font-weight: 500;
        color: ${({theme}) => theme['gray-color']}
    }

    .account-card{
        .ant-card-head{
            .ant-card-extra{
                @media only screen and (max-width: 575px){
                   padding-top: 0 !important;
                }
            }

        }

    }

    /* // Rechart */
    .recharts-default-legend{
        .recharts-legend-item{
            min-width: 100px !important;
        }
    }

    /* // Radio */
    .radio-size-wrap{
            .ant-radio-button-wrapper{
                @media only screen and (max-width: 1450px){
                    padding: 0 11.5px;
                }
                @media only screen and (max-width: 450px){
                    padding: 0 5.5px;
                }
            }
        }
    }

    /* // Message  */
    .message-button-list{
        margin: -4px;
        .ant-btn {
            margin: 4px;
        }
    }
    /* Chart Label */

    .chart-label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 6px;
        color: #5a5f7d;
    }

    .chart-label .label-dot {
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
    }

    .chart-label .label-dot.dot-success {
        background: #20c997;
    }

    .chart-label .label-dot.dot-info {
        background: #5f63f2;
    }

    .chart-label .label-dot.dot-warning {
        background: #fa8b0c;
    }

    .chart-label .label-dot {
        display: block;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 10px;
    }

    // Ant comment
    .ant-comment-actions{
        li{
            position: relative;
            &:not(:last-child){
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
                ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 8px;
                &:after{
                    position: absolute;
                    ${({theme}) => (theme.rtl ? 'left' : 'right')}: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 1px;
                    height: 12px;
                    background-color: #C6D0DC;
                    content: '';
                }
            }
            .com-time{
                cursor: default;
            }
            >span{
                ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 0;
            }
            span{
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
            }
        }

        .comment-ld-action{
            ${({theme}) => (theme.rtl ? 'padding-right' : 'padding-left')}: 8px;
            cursor: auto;
        }
    }

    .ant-comment{
        .ant-comment-content{
            .add-comment{
                margin-top: 25px;
                font-size: 14px;
                padding: 0px 25px;
                box-shadow: 0 8px 13px ${({theme}) => theme['primary-color']}20;
            }
        }
    }

    // Emoji Picker React
    .emoji-picker-react{
        bottom: 15px;
        right: 25px;
        box-shadow: 0 5px 10px #efefef10;
        @media only screen and (max-width: 479px){
            bottom: 25px;
            right: -50px;
            width: 260px;
        }
        .emoji-categories{
            padding: 0 10px;
        }
        .emoji-search{
            margin: 0 10px;
        }
        .content-wrapper:before{
            display: none;
        }
        .emoji-group{
            padding: 0 10px;
        }
        .emoji-group:before{
            font-size: 12px;
            font-weight: 600;
            color: ${({theme}) => theme['dark-color']};
        }
        .emoji-group .emoji-img{
            margin: 5px !important;
        }
    }

    .wizard-side-border{
        >.ant-card{
            .ant-card-body{
                padding: 0 25px !important;
            }
        }
        .checkout-successful{
            >.ant-card{
                .ant-card-body{
                    padding: 25px !important;
                }
            }
        }
        .payment-method-form.theme-light{
            .shipping-selection__card{
                .ant-card-body{
                    padding: 25px !important;
                }
            }
        }
        .shipping-selection__card{
            .ant-card-body{
                padding: 25px !important;
            }
        }
        .atbd-review-order{
            .ant-card-body{
                padding: 25px 25px 0 !important;
                @media only screen and (max-width: 767px) {
                    padding: 15px 15px 0 !important;
                }
            }
        }

        .ant-steps {
            padding: 50px;
            @media only screen and (max-width: 1399px) {
                padding: 25px;
            }
        }
        .steps-wrapper{
            padding: 50px;
            @media only screen and (max-width: 1399px) {
                padding: 25px;
            }
            ${({theme}) => (theme.rtl ? 'border-right' : 'border-left')}: 1px solid ${({theme}) =>
    theme['border-color-light']};
        }
    }
    .editor-compose > div {
        position: static;
        max-width: 100%;
        margin: 25px 0;
    }

    // Ant Dragger
    .ant-upload-drag{
        background-color: #fff !important;
        border-radius: 10px !important;
        display: flex;
        align-items: center;
        min-height: 100px;
        border-color: #C6D0DC;

        .ant-upload-drag-container{
            .ant-upload-text{
                margin-bottom: 0;
                font-size: 15px;
                color: #9299B8;
            }
        }
    }

    .sDash-uploader-large{
        .ant-upload-drag{
            min-height: 180px;
        }
    }

    // Form Validation
    .ant-form-item{
        .has-success{
            .ant-input{
                border-color: ${({theme}) => theme['success-color']};
            }
            &.ant-form-item-with-help{
                .ant-form-explain{
                    color: ${({theme}) => theme['success-color']};
                }
            }
        }
        &.ant-form-item-with-help{
            .ant-form-explain{
                margin: 6px 0 2px 0;
            }
        }
    }

    // Statistics Account Balance
    .sDash-ac-balance{
        .sDash-rcharge-btn{
            font-size: 14px;
            margin-top: 15px;
            height: 42px !important;
        }
    }

    // Switch Style

    .ant-switch{
        min-width: 35px;
    }

    .ant-switch-small{
        min-width: 30px;
        height: 15px;
        line-height: 15px;
    }

    // Ant Picker
    .ant-time-picker{
        min-width: 250px;
        .ant-time-picker-input{
            padding: 12px 11px;
        }
        &.ant-time-picker-large{
            .ant-time-picker-input{
                padding: 12px 11px;
            }
        }
        &.ant-time-picker-small{
            .ant-time-picker-input{
                padding: 8px 11px;
            }
        }
    }

    .sDash-dynamic-tag{
        .sDash-new-tag-input{
            background-color: #EFF0F3;
        }
        .ant-input{
            height: 30px;
        }
    }

    // Ant Tab
    .ant-tabs-top-bar{
        .ant-tabs-nav{
            margin: 0 0 16px;
            .ant-tabs-tab{
                i{
                    line-height: .6;
                }
            }
        }
    }

    // Ant Input
    .ant-input{
        padding: 12px 11px;
        &::placeholder{
            color: #9299B8;
        }
    }
    .ant-input-affix-wrapper{
        padding: 12px 11px !important;
        font-size: 14px;
    }
    .ant-input-affix-wrapper-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-affix-wrapper-sm {
        padding: 3px 7px;
    }

    .ant-input-lg{
        padding: 11.5px 11px;
        font-size: 16px;
    }

    .ant-input-sm{
        padding: 3px 7px;
    }

    #world-map{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-form-item-label{
        line-height: 1.5715;
    }
    .ant-form-vertical .ant-form-item{
        padding-bottom: 0;
    }

    .ant-checkbox-wrapper{
        span + span{
            color: ${({theme}) => theme['light-color']};
        }
    }
    .ant-menu{
        .ant-menu-item{
            svg,
            i{
                color: ${({theme}) => theme['light-color']};
            }
        }
    }
    .sDash-action-btn-list{
        &.ant-space{
            margin: -4px !important;
            .ant-space-item{
                margin: 4px !important
            }
        }
    }

    // Switch List
    .sDash-switch-list{
        margin: 0 -5px;
        button{
            margin: 0 5px;
        }
    }

    // Ant tabs
    .ant-tabs-tab-prev-icon,
    .ant-tabs-tab-next-icon{
        top: 40%;
    }

    .sDash-drawer-placement{
        .ant-radio-group{
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 8px;
        }
    }
`;

const Upload = Styled.div`
  /* // Photo Upload */
  .photo-upload{
    position: relative;
    max-width: 260px;
    margin-bottom: 30px;
    .ant-upload-select{
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border-radius: 50%;
      position: absolute;
      ${({theme}) => (!theme.rtl ? 'left' : 'right')}: 85px;
      bottom: 5px;
      z-index: 10;
      background-color: ${({theme}) => theme['white-color']};
      span{
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        z-index: -1;
        background-color: ${({theme}) => theme['primary-color']};
      }
      svg,
      i,
      span{
        color: ${({theme}) => theme['white-color']};
      }
      a{
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    img{
      border-radius: 50%;
    }
    .info{
      background-color: transparent;
    }
    figcaption{
      ${({theme}) => (theme.rtl ? 'margin-right' : 'margin-left')}: 20px;
      .info{
        h1,
        h2,
        h3,
        h4,
        h5,
        h6{
          font-size: 15px;
          font-weight: 500;
        }
      }
    }
  }
`;

const ButtonsGroupWrapper = Styled.div`
    margin-bottom: -25px;
    .button-group-single{
        margin-bottom: 15px;
        h4{
            font-size: 15px;
            margin-bottom: 8px;
        }
        .ant-btn-group{
            margin-bottom: 10px;
        }
    }
    .button-group-single .ant-btn-white{
        border: 1px solid #E3E6EF;
        background: #fff !important;
        ${({theme}) => (theme.rtl ? 'border-left-width' : 'border-right-width')}: 0px;
        &:last-child{
            ${({theme}) => (theme.rtl ? 'border-left-width' : 'border-right-width')}: 1px;
        }
        &:hover{
            color: ${({theme}) => theme['gray-color']} !important;
            background: ${({theme}) => theme['bg-color-normal']} !important;
        }
    }
    .button-group-single .ant-btn-light{
        border: 1px solid #E3E6EF;
        ${({theme}) => (theme.rtl ? 'border-left-width' : 'border-right-width')}: 0px;
        font-weight: 500;
        color: ${({theme}) => theme['extra-light-color']} !important;
        background: ${({theme}) => theme['bg-color-normal']} !important;
        &:last-child{
            ${({theme}) => (theme.rtl ? 'border-left-width' : 'border-right-width')}: 1px;
        }
    }
    .ant-btn-group:not(:last-child){
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 20px;
    }
    .ant-btn-group{
        > .ant-btn:first-child{
            ${({theme}) => (theme.rtl ? 'border-top-right-radius' : 'border-top-left-radius')}: 3px !important;
            ${({theme}) => (theme.rtl ? 'border-top-left-radius' : 'border-top-right-radius')}: 0 !important;
            ${({theme}) => (theme.rtl ? 'border-bottom-right-radius' : 'border-bottom-left-radius')}: 3px !important;
            ${({theme}) => (theme.rtl ? 'border-bottom-left-radius' : 'border-bottom-right-radius')}: 0 !important;
        }
        > .ant-btn:last-child:not(:first-child){
            ${({theme}) => (theme.rtl ? 'border-top-left-radius' : 'border-top-right-radius')}: 3px !important;
            ${({theme}) => (theme.rtl ? 'border-top-right-radius' : 'border-top-left-radius')}: 0 !important;
            ${({theme}) => (theme.rtl ? 'border-bottom-left-radius' : 'border-bottom-right-radius')}: 3px !important;
            ${({theme}) => (theme.rtl ? 'border-bottom-right-radius' : 'border-bottom-left-radius')}: 0 !important;
        }
    }
`;

const BlockButtonsWrapper = Styled.div`
    .ant-btn-block{
        margin-bottom: 10px;
    }
`;

const ButtonSizeWrapper = Styled.div`
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
`;

const BtnWithIcon = Styled.div`
    display: inline;
    .anticon i,
    .anticon svg,
    .anticon img{
        width: 10px;
        height: 10px;
    }
    .ant-btn-group button.active{
        ${({theme}) => (theme.rtl ? 'border-left' : 'border-right')}: 0px;
    }
`;

const AlertList = Styled.div`
    margin-top: -15px;

    .ant-alert{
        .ant-alert-icon{
            position: relative;
        }
        &.ant-alert-with-description{
            .ant-alert-icon{
                font-size: 15px;
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 10px;
                ${({theme}) => (theme.rtl ? 'margin-right' : 'margin-left')}: 0;
            }
        }
    }

    .alert-empty-message{
        .ant-alert{
            padding: ${({theme}) => (theme.rtl ? '10px 15px 10px 40px' : '10px 40px 10px 15px')} !important;
            &.ant-alert-no-icon{
                padding: 10px 20px 10px!important;
            }
        }
        .ant-alert-icon{
            top: 5px !important;
        }
        .ant-alert-message{
            display: none !important;
        }
    }
`;

const AutoCompleteWrapper = Styled.div`
    .ant-select:not(:last-child){
        margin-bottom: 20px;
    }
    .auto-complete-input{
        .ant-select{
            width: 200px !important;
            @media only screen and (max-width: 575px){
                width: 100% !important;
            }
        }
    }

    .autocomplete-with-btn{
        .ant-input-suffix{
            position: absolute;
            ${({theme}) => (theme.rtl ? 'left' : 'right')}:0;
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
            top: -1px;
            .search-btn{
                padding: 0px 12px !important;
                border-radius: ${({theme}) => (theme.rtl ? '4px 0 0  4px' : '0 4px 4px  0')} !important;
                height: 40px !important;
                i{
                    top: -2px !important;
                }
            }
        }
    }
`;

const CalendarWrapper = Styled.div`
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
        height: 30px !important;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item,
    .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
        line-height: 28px !important;
    }
    .ant-picker-calendar-full .ant-picker-panel .ant-picker-calendar-date-content{
        height: 105px;
    }
    .ant-radio-button-wrapper{
        height: 30px;
        line-height: 28px;
        @media only screen and (max-width: 575px){
            height: 30px !important;
            line-height: 28px !important;
        }
    }
    .ant-fullcalendar-header{
        direction: ltr;
    }
    .ant-fullcalendar-fullscreen {
        .ant-fullcalendar-content{
            text-align: ${({theme}) => (theme.rtl ? 'right' : 'left')};
            .ant-badge-status-text{
                ${({theme}) => (theme.rtl ? 'margin-right' : 'margin-left')}: 8px;
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 0;
            }
        }
        table tbody >tr >th,
        table tbody >tr >td{
            padding: 0;
        }

        .ant-fullcalendar-calendar-body{
            padding: 8px 0;
        }

        .ant-fullcalendar-header{
            .ant-fullcalendar-year-select{
                @media only screen and (max-width: 479px){
                    width: 50% !important;
                }
            }
            .ant-fullcalendar-month-select{
                @media only screen and (max-width: 479px){
                    width: calc(50% - 8px) !important;
                }
            }
            .ant-select-selector{
                @media only screen and (max-width: 479px){
                    text-align: left;
                }
            }
            .ant-radio-group{
                @media only screen and (max-width: 479px){
                    width: 100%;
                    margin-left: 0;
                    margin-top: 8px;
                }
                .ant-radio-button-wrapper{
                    width: 50%;
                    text-align: center;
                }
            }
        }
    }
`;

const DatePickerWrapper = Styled.div`
    .ant-calendar-picker{
        width: 100% !important;
        border-color: #E3E6EF;
        border-radius: 5px;
        .ant-calendar-picker-input{
            padding: 12px 11px;
        }
    }
    .ant-calendar-picker:not(:last-child){
        margin-bottom: 20px;
    }
    .ant-calendar-picker > input{
        color: #5A5F7D;
    }
    .ant-picker-range .ant-picker-input > input{
        text-align: center;
        font-weight: 500;
    }
`;

const NotificationListWrapper = Styled.div`
    margin: -4px;
    button{
        margin: 4px;
    }
`;

const TagInput = Styled.div`
    padding: 12px;
    border-radius: 4px;
    border: 1px solid ${({theme}) => theme['border-color-normal']};
    margin: -3px;
    .ant-tag{
        margin: 3px;
        font-size: 11px;
        padding: 0 4px;
        border-radius: 5px;
        border: 0 none;
        height: 24px;
        display: inline-flex;
        align-items: center;
        i{
            line-height: .6;
        }
    }
`;

const PageHeaderWrapper = Styled.div`
    .ant-page-header{
        border: 1px solid ${({theme}) => theme['border-color-normal']};
        border-radius: 5px;
        background-color: transparent !important;
        padding: 18px 20px;
        .ant-breadcrumb{
            @media only screen and (max-width: 767px){
                text-align: center;
            }
        }
    }
    .ant-page-header-heading-extra{
        color: #ddd;
        .ant-space {
            margin: -4px;
            @media only screen and (max-width: 767px){
                justify-content: center;
            }
            button{
                border-radius: 3px;
                padding: 0 18.3px;
            }
            .ant-space-item{
                margin: 4px;
            }
        }
    }
    .ant-page-header .ant-page-header-heading-left{
        margin: 2px 0;
    }
    .ant-page-header.has-breadcrumb{
        padding: 22px 25px 25px 25px;
        .ant-page-header-heading-extra{
            margin: 0 0 0 auto !important;
            @media only screen and (max-width: 767px){
                float: none;
                margin: 15px 0 auto !important;
            }

            @media only screen and (max-width: 575px){
                text-align: center;
                margin: 5px 0 auto !important;
            }
        }
    }
`;

const MessageStyleWrapper = Styled.div`
    .ant-btn-lg{
        font-size: 14px;
    }
    .ant-space{
        margin: -4px;
        .ant-space-item{
            margin: 4px;
        }
    }
`;

const BasicFormWrapper = Styled.div`
    .ant-input{
        padding: 12px 11px;
    }
    .ant-form {
        .ant-form-item-label{
            line-height: 1.45;
        }
        .form-item{
            margin-bottom: 30px;
            label{
                font-weight: 500;
                display: block;
                margin-bottom: 15px;
            }
            .ant-cascader-picker{
                width: 100%;
                min-height: 48px;
                .ant-cascader-input{
                    min-height: 48px;
                }
            }
        }

        .ant-input-affix-wrapper .ant-input-prefix svg{
            color: #9299B8;
        }
    }
    .ant-form-item-control-input{
        min-height: auto !important;
    }
    .ant-form-item{
        flex-flow: column;
        &:not(:last-child){
            margin-bottom: 26px;
        }
        &:last-child{
            margin-bottom: 0;
        }
        .ant-form-item-label{
            text-align: ${({theme}) => (theme.rtl ? 'right' : 'left')};
            label{
                height: fit-content;
                margin-bottom: 6px;
            }
        }
        .ant-form-item-control-input{
            input,
            textarea{
                color: ${({theme}) => theme['gray-color']};
                &:placeholder{
                    color: ${({theme}) => theme['light-color']};
                }
            }
            input[type="password"]{
                padding-top: 12px;
                padding-bottom: 12px;
            }
            .ant-input-affix-wrapper{
                input[type="password"]{
                    padding-top: 0;
                    padding-bottom: 0;
                }
            }
            .ant-picker-input input{
                padding: 12px;
            }
            button{
                height: 44px;
            }
            .ant-input-affix-wrapper{
                padding: 0 11px;
            }
        }
        .ant-select-single{
            .ant-select-selector{
                padding: 0 20px;
                height: 48px !important;
                border: 1px solid ${({theme}) => theme['border-color-normal']};
                .ant-select-selection-item{
                    line-height: 46px !important;
                    padding: 0 !important;
                }
                .ant-select-selection-placeholder{
                    line-height: 46px !important;
                }
            }
        }
    }
    .setting-form-actions{
        margin: 48px 0 14px;
        @media only screen and (max-width: 575px){
            margin: 40px 0 14px;
        }
        button{
            border-radius: 6px;
            height: 44px;
            margin-bottom: 14px;
            &.ant-btn-light{
                border: 1px solid ${({theme}) => theme['border-color-light']};
                background-color: ${({theme}) => theme['bg-color-light']};
            }
        }
    }
    .ant-form-item-control{
        .input-prepend{
            position: absolute;
            ${({theme}) => (theme.rtl ? 'right' : 'left')}: 0;
            top: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0 20px;
            height: 47px;
            border-radius: ${({theme}) => (theme.rtl ? '0 4px 4px 0' : '4px 0 0 4px')};
            z-index: 10;
            border: 1px solid ${({theme}) => theme['border-color-normal']};
            border-bottom: 0 none;
            background-color: ${({theme}) => theme['bg-color-light']};
            svg,
            i{
                color: ${({theme}) => theme['gray-color']};
            }
        }
        .input-prepend-wrap{
            .ant-input-number{
                input{
                    ${({theme}) => (!theme.rtl ? 'padding-left' : 'padding-right')}: 70px;
                }
            }
        }
        .ant-input-number{
            width: 100% !important;
            border: 1px solid ${({theme}) => theme['border-color-normal']};
        }
    }
    .add-record-form{
        margin: 25px 0 35px 0;

        .record-form-actions{
            padding-right: 40px;
        }
        .ant-btn{
            height: 44px;
            font-size: 14px;
            font-weight: 500;
        }
        .ant-radio-group{
            margin-bottom: -4px;
            .ant-radio-wrapper{
                margin-bottom: 4px;
            }
        }
    }
    .adTodo-form{
        .btn-adTodo {
            font-size: 14px;
        }
    }

    .sDash_form-action{
        margin: -7.5px;
        button{
            font-size: 14px;
            font-weight: 500;
            border-radius: 6px;
            margin: 7.5px;
            padding: 6.4px 19px;
            &.ant-btn-light{
                height: 44px;
                background-color: #F1F2F6;
                border-color: #F1F2F6;
            }
        }
        .ant-form-item{
            margin-bottom: 25px !important;
        }
        .ant-btn-light{
            background-color: #F8F9FB;
        }
    }
    .sDash_color-picker{
        border: 1px solid #E3E6EF;
        border-radius: 4px;
        padding: 11px 14px;
        input{
            width: 100%;
            border: 0 none;
            background-color: #fff;
            &::-webkit-color-swatch{
                min-height: 18px;
                border: 1px solid #C6D0DC;
            }
        }
    }
`;

const CardToolbox = Styled.div`
    .ant-page-header-heading{
        @media only screen and (max-width: 991px){
            flex-flow: column;
            align-items: center;
        }
    }

    .ant-page-header-heading-left{
        @media only screen and (max-width: 575px){
            flex-flow: column;
        }
        @media only screen and (max-width: 800px){
            max-width: 100%;
        }
        .ant-page-header-back{
            @media only screen and (max-width: 575px){
                margin: 0;
                padding: 0;
            }
        }
        .ant-page-header-heading-title{
            @media only screen and (max-width: 575px){
                margin: 10px 0 8px;
                padding: 0;
            }
            &:after{
                @media only screen and (max-width: 575px){
                    display: none;
                }
            }
        }
        .ant-page-header-heading-sub-title{
            @media only screen and (max-width: 575px){
                margin: 0;
                padding: 0;
                flex-flow: column;
            }
            .title-counter{
                @media only screen and (max-width: 575px){
                    margin-bottom: 16px;
                }
            }
        }
    }

    .ant-page-header-heading-title{
        position: relative;
        ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 24px;
        ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 24px;
        @media only screen and (max-width: 767px){
            ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 12px;
            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 12px !important;
        }
        &:after{
            position: absolute;
            ${({theme}) => (theme.rtl ? 'left' : 'right')}: 0px;
            top: 0;
            height: 100%;
            width: 1px;
            content: '';
            background: ${({theme}) => theme['border-color-normal']};
        }
    }
    .ant-page-header-heading-sub-title{
        font-weight: 500;
        display: flex;
        align-items: center;
        .title-counter{
            white-space: nowrap;
        }
        .ant-input-affix-wrapper{
            padding-top: 0;
            padding-bottom: 0;
            border-radius: 6px;
            border: 0 none;
            .ant-input-suffix{
                i{
                    line-height: 0;
                    svg{
                        font-size: 14px;
                        color: ${({theme}) => theme['light-gray-color']};
                    }
                }
            }
        }
    }
    .ant-select{
        ${({theme}) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 25px;
        @media only screen and (max-width: 575px){
            ${({theme}) => (!theme.rtl ? 'margin-left' : 'margin-right')}: 0;
        }
        .ant-select-selector{
            height: 46px !important;
            min-width: 350px;
            @media only screen and (max-width: 991px){
                min-width: 100%;
            }
        }
        .ant-select-selection-search-input{
            height: 46px;
            border-radius: 23px;
            border: 0 none;
            box-shadow: 0 5px 20px #9299B803;
            input{
                height: 46px !important;
                font-size: 14px;
            }
        }
    }
    .btn-add_new{
        border-radius: 6px;
        height: 40px;
        padding: 0 14px;
        font-size: 12px;
        @media only screen and (max-width: 991px){
            margin-top: 10px;
        }
        a{
            display: flex;
            align-items: center;
            svg{
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
            }
        }
    }
`;

const FormGroupWrapper = Styled.div`
    .ant-card-body{
        @media only screen and (max-width: 767px){
            padding: 0 !important;
        }
    }
`;
const BannerCardStyleWrap = Styled.div`
    .ant-card-body{
        padding: 25px 25px 0 25px !important;
    }
`;

const FileCardWrapper = Styled.div`
    .file-list{
        min-height: 385px;
        .file-list__single{
            justify-content: space-between;
            align-items: center;
            &:not(:last-child){
                margin-bottom: 18px;
            }
            span{
                display: block;
                font-size: 12px;
                line-height: 1.42;
                &.file-name{
                    font-size: 14px;
                    font-weight: 500;
                    color: ${({theme}) => theme['dark-color']};
                }
                &.file-size{
                    margin: 2px 0;;
                    color: ${({theme}) => theme['gray-solid']};
                }
                &.file-content-action{
                    a{
                        font-weight: 500;
                        color: ${({theme}) => theme['primary-color']};
                    }
                    a + a{
                        margin-left: 8px;
                    }
                }
            }
        }
        .file-single-info{
            width: 50%;
            align-items: center;
            .file-single-logo{
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 16px;
                img{
                    max-width: 42px;
                }
            }
        }
        .file-single-action{
            .ant-dropdown-trigger {
                color: ${({theme}) => theme['extra-light-color']};
            }
        }
    }
`;

const TableStyleWrapper = Styled.div`
  padding: 25px;
  background: #fff;
  border-radius: 10px
  table{
    tbody{
      td{
        .user-info{
          .user-name{
            font-size: 14px;
          }
        }
        span.status-text{
          font-size: 12px;
          padding: 0 12.41px;
          line-height: 1.9;
          font-weight: 500;
          border-radius: 12px;
          text-transform: capitalize;
          display: inline-block !important;
          background: #ddd;
          &.active{
            background-color: ${({theme}) => theme['success-color']}15;
            color: ${({theme}) => theme['success-color']};
          }
          &.inactive{
            background-color: ${({theme}) => theme['danger-color']}15;
            color: ${({theme}) => theme['warning-color']};
          }
            background-color: ${({theme}) => theme['warning-color']}15;
            color: ${({theme}) => theme['warning-color']};
          }
          &.blocked{
            background-color: ${({theme}) => theme['danger-color']}15;
            color: ${({theme}) => theme['danger-color']};
          }
        }
      }
    }
    .table-actions{
      min-width: 150px !important;
    }
  }
  .ant-table-pagination.ant-pagination{
    width: 100%;
    text-align: ${({theme}) => (!theme.rtl ? 'right' : 'left')};
    border-top: 1px solid ${({theme}) => theme['border-color-light']};
    margin-top: 0 !important;
    padding-top: 30px;
    @media only screen and (max-width: 767px){
      text-align: center;
    }
  }
  .contact-table{
    table{
      tr{
        th{
          &:first-child{
            ${({theme}) => (theme.rtl ? 'padding-right' : 'padding-left')}: 20px;
          }
          &:last-child{
            ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 20px;
          }
        }
      }
      .table-actions{
        button{
          width: auto;
          height: auto;
          padding: 0;
          background-color: transparent;
          &:hover{
            background-color: transparent;
          }
          &.ant-btn-primary{
            &:hover{
              color: #ADB4D2;
            }
          }
        }
      }
      tbody >tr.ant-table-row-selected >td{
        background-color: ${({theme}) => theme['primary-color']}10;
      }
    }
  }
`;

const TableStyleWrapper2 = Styled.div`
  padding: 0;
  background: #fff;
  border-radius: 10px
  table{
    tbody{
      td{
        .user-info{
          .user-name{
            font-size: 14px;
          }
        }
        span.status-text{
          font-size: 12px;
          padding: 0 12.41px;
          line-height: 1.9;
          font-weight: 500;
          border-radius: 12px;
          text-transform: capitalize;
          display: inline-block !important;
          background: #ddd;
          &.active{
            background-color: ${({theme}) => theme['success-color']}15;
            color: ${({theme}) => theme['success-color']};
          }
          &.inactive{
            background-color: ${({theme}) => theme['danger-color']}15;
            color: ${({theme}) => theme['warning-color']};
          }
            background-color: ${({theme}) => theme['warning-color']}15;
            color: ${({theme}) => theme['warning-color']};
          }
          &.blocked{
            background-color: ${({theme}) => theme['danger-color']}15;
            color: ${({theme}) => theme['danger-color']};
          }
        }
      }
    }
    .table-actions{
      min-width: 150px !important;
    }
  }
  .ant-table-pagination.ant-pagination{
    width: 100%;
    text-align: ${({theme}) => (!theme.rtl ? 'right' : 'left')};
    border-top: 1px solid ${({theme}) => theme['border-color-light']};
    margin-top: 0 !important;
    padding-top: 30px;
    @media only screen and (max-width: 767px){
      text-align: center;
    }
  }
  .contact-table{
    table{
      tr{
        th{
          &:first-child{
            ${({theme}) => (theme.rtl ? 'padding-right' : 'padding-left')}: 20px;
          }
          &:last-child{
            ${({theme}) => (theme.rtl ? 'padding-left' : 'padding-right')}: 20px;
          }
        }
      }
      .table-actions{
        button{
          width: auto;
          height: auto;
          padding: 0;
          background-color: transparent;
          &:hover{
            background-color: transparent;
          }
          &.ant-btn-primary{
            &:hover{
              color: #ADB4D2;
            }
          }
        }
      }
      tbody >tr.ant-table-row-selected >td{
        background-color: ${({theme}) => theme['primary-color']}10;
      }
    }
  }
`;

const TableWrapper = Styled.div`
    .ant-pagination-prev, .ant-pagination-next {
        line-height: 28px !important;
        transform: rotateY(${({theme}) => (theme.rtl ? '180deg' : '0deg')})
    }
    .ant-table table{
        text-align: ${({theme}) => (!theme.rtl ? 'left' : 'right')};
    }
    .ant-table-thead > tr > th{
        text-align: ${({theme}) => (!theme.rtl ? 'left' : 'right')};
    }
    span.anticon.anticon-right{
        transform: rotateY(${({theme}) => (theme.rtl ? '180deg' : '0deg')})
    }
    span.anticon.anticon-left{
        transform: rotateY(${({theme}) => (theme.rtl ? '180deg' : '0deg')})
    }
    .ant-table-tbody > tr > td.ant-table-selection-column{
        text-align: left;
    }
    &.table-order,
    &.table-seller,
    &.table-data-view{
        .ant-table-selection{
            .ant-checkbox-indeterminate{
                .ant-checkbox-inner{
                    background: ${({theme}) => theme['primary-color']};
                    border-color: ${({theme}) => theme['primary-color']};
                    &:after{
                        height: 2px;
                        background-color: #fff;
                    }
                }
            }
        }
        .ant-table-container{
            padding-bottom: 25px;
            border-bottom: 1px solid ${({theme}) => theme['border-color-light']};
        }
        tbody{
            tr{
                &:hover{
                    td{
                        background: ${({theme}) => theme['bg-color-light']};
                    }
                }
                td{
                    .product-id{
                        max-width: 60px;
                        text-align: ${({theme}) => (theme.rtl ? 'left' : 'right')};
                    }
                }
            }
        }
        .ant-pagination{
            margin-top: 25px !important;
        }
    }
    &.table-data-view{
        .ant-table-container{
            padding-bottom: 0;
        }
        table{
            thead{
                th{
                    padding: 15px 16px;
                }
            }
            tbody{
                td{
                    padding: 11px 16px;
                    .record-img{
                        img{
                            max-width: 38px;
                            min-height: 38px;
                            border-radius: 50%;
                            ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 12px;
                        }
                    }
                    .record-location{
                        display: block;
                        font-size: 12px;
                        font-weight: 400;
                        color: ${({theme}) => theme['light-color']};
                    }
                    .status{
                        font-weight: 500;
                        text-transform: capitalize;
                        &.active{
                            color: ${({theme}) => theme['success-color']};
                            background: ${({theme}) => theme['success-color']}10;
                        }
                        &.deactivated{
                            color: ${({theme}) => theme['warning-color']};
                            background: ${({theme}) => theme['warning-color']}10;
                        }
                        &.blocked{
                            color: ${({theme}) => theme['danger-color']};
                            background: ${({theme}) => theme['danger-color']}10;
                        }
                    }
                    .table-actions{
                        a{
                            svg, i{
                                width: 16px;
                                color: ${({theme}) => theme['extra-light-color']};
                            }
                            &.edit{
                                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 6px;
                              &:hover{
                                svg,
                                i{
                                    color: ${({theme}) => theme['info-color']};
                                }
                              }
                            }
                            &.delete{
                              &:hover{
                                svg,
                                i{
                                    color: ${({theme}) => theme['danger-color']};
                                }
                              }
                            }
                        }
                    }
                }
            }
        }
    }
    table{
        thead{
            tr{
                border-radius: 10px;
                th{
                    &:last-child{
                        text-align: ${({theme}) => (theme.rtl ? 'left' : 'right')};
                    }
                    color: ${({theme}) => theme['gray-color']};
                    background: ${({theme}) => theme['bg-color-light']};
                    border-top: 1px solid ${({theme}) => theme['border-color-light']};
                    border-bottom: 1px solid ${({theme}) => theme['border-color-light']};
                    &:first-child{
                        ${({theme}) => (!theme.rtl ? 'border-left' : 'border-right')}: 1px solid ${({theme}) =>
    theme['border-color-light']};
                        border-radius: ${({theme}) => (!theme.rtl ? '10px 0 0 10px' : '0 10px 10px 0')} !important;
                    }
                    &:last-child{
                        ${({theme}) => (theme.rtl ? 'border-left' : 'border-right')}: 1px solid ${({theme}) =>
    theme['border-color-light']};
                        border-radius: ${({theme}) => (!theme.rtl ? '0 10px 10px 0' : '10px 0 0 10px')} !important;
                    }
                }
            }
        }
        tbody{
            tr{
                &:hover{
                    td{
                        background: ${({theme}) => theme['bg-color-light']};
                    }
                }
                &.ant-table-row-selected{
                    &:hover{
                        td{
                            background: ${({theme}) => theme['bg-color-light']};
                        }
                    }
                    td{
                        background: ${({theme}) => theme['bg-color-light']};
                    }
                }
                td{
                    border: 0 none;
                    font-weight: 500;
                    color: ${({theme}) => theme['dark-color']};
                    &:first-child{
                        border-radius: ${({theme}) => (!theme.rtl ? '10px 0 0 10px' : '0 10px 10px 0')} !important;
                    }
                    &:last-child{
                        border-radius: ${({theme}) => (!theme.rtl ? '0 10px 10px 0' : '10px 0 0 10px')} !important;
                    }
                    span{
                        display: block;
                    }
                    .order-id{
                        min-width: 128px;
                    }
                    .customer-name{
                        min-width: 174px;
                    }
                    .status.warning{
                        min-width: 131px;
                        display: inline-block !important;
                    }
                    .ordered-amount{
                        min-width: 175px;
                    }
                    .ordered-date{
                        min-width: 165px;
                    }
                    .table-actions{
                        min-width: 60px;
                    }
                }
            }
        }
        .table-actions{
            text-align: ${({theme}) => (theme.rtl ? 'left' : 'right')};
            min-width: 115px !important;
            button{
                height: 40px;
                padding: 0 11px;
                background: transparent;
                border: 0 none;
                color: ${({theme}) => theme['extra-light-color']};
                &:hover{
                    &.ant-btn-primary{
                        color: ${({theme}) => theme['primary-color']};
                        background: ${({theme}) => theme['primary-color']}10;
                    }
                    &.ant-btn-info{
                        color: ${({theme}) => theme['info-color']};
                        background: ${({theme}) => theme['info-color']}10;
                    }
                    &.ant-btn-danger{
                        color: ${({theme}) => theme['danger-color']};
                        background: ${({theme}) => theme['danger-color']}10;
                    }
                }
            }
        }
        .seller-info{
            img{
                ${({theme}) => (theme.rtl ? 'margin-left' : 'margin-right')}: 12px;
            }
        }
        .user-info{
            display: flex;
            align-items: center;
            figure{
                margin: 0 8px 0;
            }
            .user-name{
                margin-bottom: 4px;
                font-weight: 500;
            }
            .user-designation{
                font-size: 12px;
                font-weight: 400;
                color: ${({theme}) => theme['light-color']};
            }
        }
    }
`;

const DragDropStyle = Styled.div`
    .ant-card-body{
        padding: 15px !important;
    }
    table{
        thead{
            display: none;
        }
        tbody{
            >tr{
                &:not(:last-child){
                    td{
                         border-bottom: 1px solid ${({theme}) => theme['border-color-normal']} !important;
                    }
                 }
                 &:hover{
                     td{
                         background-color: transparent !important;
                     }
                 }
                >td{
                    font-size: 14px;
                    &:first-child,
                    &:last-child{
                        border-radius: 0 !important;
                    }
                }
            }
        }
        tr{
            td{
                svg,
                img{
                    width: 20px;
                }
                svg,
                i{
                    color: ${({theme}) => theme['extra-light-color']} !important;
                }
            }

        }
        .user-info{
            .user-name{
                font-size: 14px;
                margin-left: 8px;
            }
        }
    }
`;

const ImportStyleWrap = Styled.div`
    .ant-upload.ant-upload-drag{
        background-color: #fff;
        min-height: 280px;
        display: flex;
        align-items: center;
        border-color: #C6D0DC;
        border-radius: 10px;
        .ant-upload-drag-icon{
            svg,
            i{
                color: #ADB4D2;
            }
        }
    }
    .sDash_import-inner{
        .ant-upload-text{
            font-size: 20px;
            font-weight: 500;
        }
        .ant-upload-hint{
            margin-left: 4px;
            span{
                color: ${({theme}) => theme['primary-color']};
            }
        }
        .ant-upload-list{
            .ant-upload-list-item{
                background-color: #fff;
                border-color: ${({theme}) => theme['border-color-normal']};
            }
            .ant-upload-list-item-card-actions.picture{
                top: 18px;
                ${({theme}) => (!theme.rtl ? 'right' : 'left')}: 15px;
            }
        }
    }
`;

const ExportStyleWrap = Styled.div`
    .sDash_export-box{
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;
        @media only screen and (max-width: 575px){
            flex-flow: column;
        }
        .ant-input-affix-wrapper{
            background-color: transparent;
            border: 1px solid #e3e6ef;
            padding: 12px 13px;
            width: 250px;
            height: 40px;
            display: flex;
            align-items: center;
            border-radius: 20px;
            .ant-input-prefix{
                i{
                    svg{
                        color: #9299B8;
                    }
                }
            }
        }
        .btn-export{
            height: 44px;
            @media only screen and (max-width: 575px){
                margin-bottom: 20px;
            }
        }
        .ant-select{
            width: auto !important;
            .ant-select-selector{
                padding: 0 20px;
                .ant-select-selection-search-input{
                    border-radius: 20px;
                }
            }
        }
    }
    .sDash_export-file-table{
        .ant-table-content{
            .ant-table-thead{
                border: 1px solid ${({theme}) => theme['border-color-light']};
                border-radius: 10px;
                tr{
                    th{
                        background-color: ${({theme}) => theme['bg-color-light']};
                        border: 0 none;
                        color: ${({theme}) => theme['gray-color']};
                        &:first-child{
                            border-radius: 10px 0 0 10px;
                        }
                        &:last-child{
                            border-radius: 0 10px 10px 0;
                        }
                    }
                }
            }
            .ant-table-tbody{
                tr{
                    &:hover{
                        box-shadow: 0 15px 50px #9299B820;
                        td{
                            background-color: #fff !important;
                        }
                    }
                    td{
                        border: 0 none;
                        padding: 22px 25px;
                        background-color: #fff;
                    }
                }
            }
        }
    }
`;

const FormValidationWrap = Styled.div`
    .ant-card-body{
        padding: 30px 25px 50px 25px !important;
    }
    .ant-form-item .has-error{
        .ant-form-explain{
            font-size: 13px;
        }
    }
    .sDash_agree-check{
        .ant-form-item-control-input{
            min-height: auto;
        }
        .ant-form-item .has-error{
            .ant-checkbox-wrapper{
                span{
                    font-size: 13px;
                }
                .ant-checkbox{
                    border-color: ${({theme}) => theme['danger-color']}30;
                    &.ant-checkbox-checked{
                        border-color: ${({theme}) => theme['danger-color']}30;
                        &:after{
                            border-color: ${({theme}) => theme['danger-color']}30;
                        }
                        .ant-checkbox-inner{
                            &:after{
                                border-color: ${({theme}) => theme['danger-color']};
                            }
                        }
                    }
                    .ant-checkbox-inner{
                        border-color: ${({theme}) => theme['danger-color']}30;
                        background-color: ${({theme}) => theme['danger-color']}30;
                    }
                }
            }
        }
        .ant-form-item-explain{
            margin-left: 25px;
            font-size: 13px;
        }
    }
    .sDash_form-action{
        button{
            border-radius: 4px;
            padding: 6.4px 29.2px;
            height: 44px;
        }
    }
`;
const InfoWrapper = Styled.section`
    margin-bottom: 10px!important;
    .info-title{
        font-weight: 500;
        color: rgb(39, 43, 65);
    }
    
    .info-text{
        font-size: 14px;
        color: rgb(90, 95, 125);
    }
`;

const TimelineBoxWrap = Styled.div`
  .ant-timeline-item-last > .ant-timeline-item-tail{
    display: block;
  }
  .ant-timeline-item{
    .ant-timeline-item-head{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme['bg-color-light']};
    }
    &.ant-timeline-item-left{
      .ant-timeline-item-content{
        &:after{
          position: absolute;
          content: '';
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          ${({ theme }) => (theme.rtl ? 'border-left' : 'border-right')}: 16px solid #EFF0F3;
          border-bottom: 8px solid transparent;
          top: 60%;
          transform: translateY(-50%);
          ${({ theme }) => (theme.rtl ? 'right' : 'left')}: -16px;
        }
      }
    }
    &.ant-timeline-item-right{
      .ant-timeline-item-content{
        ${({ theme }) => (theme.rtl ? 'left' : 'right')}: 6px;
        &:after{
          position: absolute;
          content: '';
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          ${({ theme }) => (theme.rtl ? 'border-right' : 'border-left')}: 16px solid #EFF0F3;
          border-bottom: 8px solid transparent;
          top: 60%;
          transform: translateY(-50%);
          ${({ theme }) => (theme.rtl ? 'left' : 'right')}: -16px;
        }
        .content-box{
          text-align: left !important;
        }
      }
    }
    .ant-timeline-item-content{
      h2{
        font-size: 14px;
        color: ${({ theme }) => theme['extra-light-color']};
      }
      .content-box{
        font-size:12px
        padding: 18px 20px;
        border-radius: 10px;
        background-color: #EFF0F3;
        p{
          line-height: 1.75;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
  }
`;

const CheckListWrap = Styled.div`
    .sDash_check-list-wrap{
        display: flex;
        justify-content: space-between;
        .sDash_check-list{
            li{
                &:not(:last-child){
                    margin-bottom: 20px;
                }
            }
        }
    }
`;


export {
    Main,
    ModalMain,
    Upload,
    ButtonsGroupWrapper,
    BlockButtonsWrapper,
    ButtonSizeWrapper,
    BtnWithIcon,
    AlertList,
    AutoCompleteWrapper,
    CalendarWrapper,
    DatePickerWrapper,
    NotificationListWrapper,
    TagInput,
    PageHeaderWrapper,
    MessageStyleWrapper,
    BasicFormWrapper,
    CardToolbox,
    FormGroupWrapper,
    DragDropStyle,
    BannerCardStyleWrap,
    FileCardWrapper,
    TableWrapper,
    ImportStyleWrap,
    ExportStyleWrap,
    FormValidationWrap,
    InfoWrapper,
    RelationMain,
    TimelineBoxWrap,
    TableStyleWrapper,
    TableStyleWrapper2,
    CheckListWrap,
};
